module.exports = __webpack_public_path__ + "static/media/forgot.e5585993.jpg";